import React from "react";
import RichText from "./RichText";

const TimelinePatterns = ({ timing }) => {
  if (!timing) return null;
  return (
    <div className="abr-card is-white">
      <div className="abr-card-title">Timing patterns</div>
      <p className="abr-card-sub">
        When matched buyers want to be in a new home, drawn from their stated TimeLine.
      </p>
      <div style={{ marginTop: 12 }}>
        {timing.buckets.map((bucket, idx) => (
          <div
            key={`${bucket.label}-${idx}`}
            className={`abr-timing-row${bucket.accent ? " is-accent" : ""}`}
          >
            <div className="abr-timing-label">{bucket.label}</div>
            <div className="abr-timing-track">
              <div className="abr-timing-fill" style={{ width: `${bucket.pct}%` }} />
            </div>
            <div className="abr-timing-pct">{bucket.pct}%</div>
          </div>
        ))}
      </div>
      <RichText as="p" className="abr-insight-caption" text={timing.caption} />
    </div>
  );
};

export default TimelinePatterns;
